import Vue from 'vue'
import Vuex from 'vuex'
import login_module from './login/index'
import {Toast} from 'vant'
import {request} from '@/utils/request'

Vue.use(Vuex)
Vue.use(Toast)

export default new Vuex.Store({
    state: {
        hxjs: [],//核心技术
        xwzx: [], //新闻资讯
        gcal: [],//工程案例
        gsdt: [],//公司动态
        lb: [],//轮播
        zpxx: [],//招聘信息
        homeTs: [],//首页介绍
        rlzy: [],//人力资源
        tpzj: [],//特聘专家
        yfpt: [],//研发平台
        yfptBt: [],//研发平台标题
    },
    mutations: {
        setYfpt(state, hxjs) {//研发平台
            state.yfpt = hxjs
        },
        setYfptBt(state, hxjs) {//研发平台标题
            state.yfptBt = hxjs
        },
        setHxjs(state, hxjs) {//核心技术
            state.hxjs = hxjs
        },
        setGcal(state, gcal) {//工程案例
            state.gcal = gcal
        },
        setLb(state, lb) {//lb
            state.lb = lb
        },
        setGsdt(state, dt) {//动态
            state.gsdt = dt
        },
        setXwzx(state, dt) {//动态
            state.xwzx = dt
        },
        setZpxx(state, dt) {//
            state.zpxx = dt
        },
        setHomeJs(state, dt) {//
            state.homeTs = dt
        },
        setRlzy(state, dt) {//
            state.rlzy = dt
        },
        setTpzj(state, dd) {//特聘专家
            state.tpzj = dd
        }
    },
    actions: {
        async post(context, {url = '', data, showToast = true}) {

            let res
            await request('POST', url, data)
                .then(json => {
                    res = json
                })

            Toast.clear()
            if (res.code != 0) {


                if (showToast)
                    Toast.fail(res.message);
                return null
            }
            return res
        },
        async get(context, {url, data, showToast = true}) {
            let res
            await request('GET', url, data)
                .then(json => {
                    res = json
                })
            Toast.clear()
            if (res.code != 0) {

                if (showToast)
                    Toast.fail(res.message);
                return null
            }

            return res
        }
    },
    modules: {
        login: login_module
    }
})
